<button mat-raised-button class="phonebook-btn" color="" (click)="openPhonebook()">
  <mat-icon>phone</mat-icon>
  {{ "PHONEBOOK" | translate }}
</button>